exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DeviceSummaryItem{margin:0px 0px;width:100%;height:100%;text-align:center}.DeviceSummaryItem-ImageContainer{width:100%;height:70%;background-size:contain;background-repeat:no-repeat;background-position:center}.DeviceSummaryItem-Name{margin-top:10px;font-size:14px;color:var(--text-primary)}", ""]);

// exports
